module.exports = __webpack_public_path__ + "img/personalcenter-checkbox-unselected.e834fe27.svg";